import React from 'react';
import { Grid } from '@mui/material';
import Box from '@components/Atoms/Box';
import Typography from '@components/Atoms/Typography';
import { useCurriculumDetails } from '@reducers/curriculums/hooks';
import { useHasSectionAllCourseExams } from '@components/Component/Exams/hooks/helpers';
import useWebSocketListener from '@components/Component/Exams/hooks/useWebSocketListener';
import useExamScaledScore from '@components/Component/Exams/hooks/useAverageExamScore';
import ShowIf from '@components/Atoms/ShowIf';

const TestSessionScoresCard = () => {
  const { overall_scaled_score: overAllScaledScore, subscores } = useExamScaledScore();
  const curriculumDetails = useCurriculumDetails();
  const HasAllExamSectionsScheduled = useHasSectionAllCourseExams();

  useWebSocketListener();

  return (
    <Box sx={{ m: 2, backgroundColor: 'white', borderRadius: 2, p: 2 }} data-testid="test-session-scores-card">
      <Grid container spacing={2} alignItems="stretch">
        <Grid size={{ xs: 12, sm: 3 }}>
          <Box
            sx={{
              background: 'white',
              borderRadius: 2,
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="body2" sx={{ color: 'grey.600', mb: 1 }}>
              {curriculumDetails.name}
            </Typography>

            <ShowIf If={HasAllExamSectionsScheduled && Boolean(overAllScaledScore?.max_score)}>
              <>
                <Typography component="p" sx={{ fontWeight: 700, mb: 0.5, fontSize: '3rem' }}>
                  {overAllScaledScore?.score ? Math.round(overAllScaledScore?.score) : '--'}
                </Typography>
                <Typography variant="body2" sx={{ color: 'grey.600' }}>
                  out of {overAllScaledScore?.max_score}
                </Typography>
              </>
            </ShowIf>
          </Box>
        </Grid>
        {subscores?.map(({ id, name, score }) => (
          <Grid size={{ xs: 12, sm: 2.25 }} key={id}>
            <Box
              sx={{
                background: 'white',
                borderRadius: 1,
                border: '1px solid',
                borderColor: 'grey.200',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography variant="body2" sx={{ color: 'grey.600', mb: 1 }}>
                {name}
              </Typography>
              <Typography component="p" variant="h3" sx={{ fontWeight: 600, mb: 0.5, color: 'black' }}>
                {score?.scaled_score ? Math.round(score?.scaled_score) : '--'}
              </Typography>
              <Typography variant="body2" sx={{ color: 'grey.600' }}>
                {score?.max_scaled_score
                  ? `out of ${Math.round(score?.max_scaled_score)}`
                  : '--'}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default TestSessionScoresCard;
